import { Component } from '@angular/core';

@Component({
  selector: 'app-self-assessment-link',
  templateUrl: './self-assessment-link.component.html',
  styleUrls: ['./self-assessment-link.component.scss']
})
export class SelfAssessmentLinkComponent {

}
